import { render, staticRenderFns } from "./GoodSearch.vue?vue&type=template&id=35c05e62&scoped=true&"
import script from "./GoodSearch.vue?vue&type=script&lang=js&"
export * from "./GoodSearch.vue?vue&type=script&lang=js&"
import style0 from "./GoodSearch.vue?vue&type=style&index=0&id=35c05e62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c05e62",
  null
  
)

export default component.exports